<app-topbar></app-topbar>
<div class="container mr-top-56" *ngIf = "divReady">
			
    <!-- Payment Detail -->
        <div class="common row mr-top-20 mr-bttm-68 frMbl">
            <div class="col-md-12 prfl_data_side">
                <h1 class="mainhdng mr-bttm-30">Payment & Billing</h1>
                <div *ngIf="showNoRecord;else Subscription">
                    <div class="container cntremptyscrn">
                        <div class="row h-80 justify-content-center align-items-center">
                            <div class="common noproductsdiv text-center">
                                <img src="assets/images/products-n-subscriptions.png" class="noprdctimg">
                                <h3 class="noprdcrthdng">You don’t have any products yet </h3>
                                <p class="noprdcrt_subhdng">Click below to select a product subscription</p>
                                <button routerLink = "/dashboard" class="getstrtd noinfobttn">Get Started</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <ng-template #Subscription>
                   
                   
                    <a class="d-none" id="download_invoice" href="https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf" download target="_blank" >Download</a>
                    <div class="common addcompanymain marginbottomsamesec col-md-6 newproductpayment">
						 <div class="prflhdng mr-bttm-20">
                           <h6 class="pyhdng mr-bttm-5">Apps </h6>
                    	 </div>
						<div *ngFor = "let payment of transactions" style="margin-bottom:20px;float:left;width:100%;">
                       <!-- <div class="caddtitle">
                           <p class="viewnorr viewnorroview">#00{{payment.id}}</p> 
                            <p class="countnotification countnotificationoview text-right"><b>Total: ${{payment.free_trial_days != '0' ? payment.subscrition_amount : '0'}}</b><br/></p> 
                            <p *ngIf ="payment.license_changed == '1'" class="countnotification countnotificationoview text-right"><b>Plan Changed</b></p> 
                        </div>-->
						
                        <div class="prodsubistsecmian newAdding">
                            <div class="prodsubistsec">
                                <img src="{{product_image_url}}{{payment.icon}}"/>
                                <div class="istsecontent">
                                    <h4>{{payment.name}}</h4>
                                    <p>{{payment.created_at}}</p>
                                    
                                </div>
                            </div>
                            <!-- <div class="prodsubsecondsec">
                                <h4>Plan</h4>
                                <p>{{payment.package_name}} Plan, <span class="pyment_interval">{{payment.package_interval}}ly</span> payment</p>
                            </div> -->
                           
                            <div *ngIf ="payment.free_trial == '0'" class="prodsubsecondsec text-right float-right">
                                <h4>Total: ${{payment.total_amount}}</h4>
								<a href="javascript:void(0)" (click) ="downloadClick(payment.id)" class="downnew">Download Invoice</a>
                            </div>
                            <div *ngIf ="payment.free_trial == '1'" class="prodsubsecondsec text-right float-right">
                                <h4>Total: $0</h4>
								<a href="javascript:void(0)" (click) ="downloadClick(payment.id)" class="downnew">Download Invoice</a>
                            </div>
                        </div>
					</div>
                    </div>
					 <div class="common addcompanymain marginbottomsamesec col-md-6 newproductpayment" >
                         <div class="prflhdng mr-bttm-20">
                           <h6 class="pyhdng mr-bttm-5">Credits </h6>
                    	 </div>
						 <div *ngFor = "let payment of transactionscredit" style="float:left;width:100%;margin-bottom:20px;">
                        <div class="prodsubistsecmian newAdding">
                            <div class="prodsubistsec">
                                <img src="{{product_image_url}}{{payment.icon}}"/>
                                <div class="istsecontent">
                                    <h4>{{payment.name}}</h4>
                                    <p>{{payment.created_at}}</p>
                                    
                                </div>
                            </div>
                           
                            <div *ngIf ="payment.free_trial == '0'" class="prodsubsecondsec text-right float-right">
                                <h4>Total: ${{payment.total_amount}}</h4>
								<a href="javascript:void(0)" (click) ="downloadClick(payment.id)" class="downnew">Download Invoice</a>
                            </div>
                            <div *ngIf ="payment.free_trial == '1'" class="prodsubsecondsec text-right float-right">
                                <h4>Total: $0</h4>
								<a href="javascript:void(0)" (click) ="downloadClick(payment.id)" class="downnew">Download Invoice</a>
                            </div>
                        </div>
						 </div>
                        
                    </div>
                    
                </ng-template>

            </div>

        </div>
    

</div>